import { render, staticRenderFns } from "./SingleAnswerSelect.vue?vue&type=template&id=034fd1db&scoped=true"
import script from "./SingleAnswerSelect.vue?vue&type=script&lang=js"
export * from "./SingleAnswerSelect.vue?vue&type=script&lang=js"
import style0 from "./SingleAnswerSelect.vue?vue&type=style&index=0&id=034fd1db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034fd1db",
  null
  
)

export default component.exports